export default "__VITE_ASSET__DP7J8gMR__"